import React, { useCallback } from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import styled from 'styled-components';
import AlertsComponent from 'components/Alert/AlertsComponent';
import { InsuranceOffer } from 'types/Product';
import IconBrendProtect from '@tvg/fuse-icons/lib/BrandProtect';
import { Icon, Link, TypographyComponent as TypographyElement } from '@tvg/fuse-design';

import { getSite } from 'context/SiteContext';
import { InsuranceNotification } from './InsuranceNotification/InsuranceNotification';
import { InsuranceSelector } from './InsuranceSelector/InsuranceSelector';
import { InsuraceDescription } from './InsuranceDescription/InsuranceDescription';

const InsuranceContainer = styled.div`
  padding-top: var(--spacing-space16);
  margin-bottom: var(--spacing-space16);
`;

const StyledTypography = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
`;

const FindOutMore = styled(Link)`
  cursor: pointer;
  margin-bottom: var(--spacing-space24);
`;

export function Insurance() {
  const {
    selectedSku,
    setCheckItsRightDialog,
    setSelectedInsurance,
    insuranceError,
    selectedInsurance,
    selectedSkuInsuranceContent,
    setFindOutMore,
    skus,
  } = useSelectedSkuContext();

  const firstInsuranceSKU = skus.find((sku) => sku.insuranceOffers && sku.insuranceOffers);

  const notificationTitle =
    firstInsuranceSKU?.insuranceOffers &&
    firstInsuranceSKU?.insuranceOffers[0]?.offer?.productDescription.replace(' Monthly', '');

  const title =
    selectedSku?.insuranceOffers && selectedSku?.insuranceOffers[0]?.offer?.productDescription.replace(' Monthly', '');

  const handleIfItsRightOpen = (option: InsuranceOffer | null) => {
    setSelectedInsurance(option);
    setCheckItsRightDialog(true);
  };

  const handleFindOutMore = () => {
    setFindOutMore(true);
    setCheckItsRightDialog(true);
  };

  const handleNoInsuranceSelect = useCallback(() => {
    setSelectedInsurance('No insurance');
  }, []);

  const IconContainer = styled.div`
    flex: 0 0 32px;
    margin-right: var(--spacing-space12);
    position: relative;
    bottom: 4px;
  `;

  const TitleContainer = styled.div`
    display: flex;
  `;

  const covered =
    selectedSku &&
    selectedSkuInsuranceContent?.insuranceContent.pdpInsuranceDescription[2].find((item) =>
      Object.keys(item).includes('bulletText'),
    );
  const site = getSite() === 'littlewoods' ? 'Littlewoods' : 'Very';
  if (selectedSku && !selectedSku.insuranceOffers) return null;
  if (selectedSku && selectedSku.insuranceOffers && selectedSkuInsuranceContent) {
    return (
      <InsuranceContainer id="insurance-container">
        <TitleContainer>
          <IconContainer>
            <Icon icon={<IconBrendProtect />} width="32px" height="32px" dataTestId="insurance-title-icon" />
          </IconContainer>
          <StyledTypography size="1" tag="p" dataTestId="insurance-component-title">
            {selectedSkuInsuranceContent?.insuranceContent.pdpInsuranceDescription[0][0].text ||
              selectedSkuInsuranceContent?.insuranceContent.pdpInsuranceDescription[0][0].title}
          </StyledTypography>
        </TitleContainer>
        <InsuraceDescription
          covered={covered?.bulletText}
          description={selectedSkuInsuranceContent.insuranceContent.pdpInsuranceDescription[1][0].text}
          boldDescription={selectedSkuInsuranceContent.insuranceContent.pdpInsuranceDescription[1][1].text}
        />
        <FindOutMore onClick={() => handleFindOutMore()} size="medium" data-testid="insurance-find-out-more">
          {`Find out more about ${site} ${title?.split('-')[0].trimEnd()}`}
        </FindOutMore>
        {insuranceError && <AlertsComponent errorMessage="Please select an insurance option." />}
        <InsuranceSelector
          options={selectedSku.insuranceOffers}
          handleSelectedInsurance={handleIfItsRightOpen}
          handleNoInsuranceSelect={handleNoInsuranceSelect}
          selectedInsurance={selectedInsurance}
          skuId={selectedSku.itemNumber}
        />
      </InsuranceContainer>
    );
  }
  return (
    <InsuranceContainer id="insurance-container">
      <InsuranceNotification title={`${site} ${notificationTitle} Insurance`} />
    </InsuranceContainer>
  );
}

export default Insurance;
